(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/amount/amount.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/amount/amount.js');


'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
class Amount extends svs.tur.Base {
  constructor(_ref) {
    let _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 0 : _ref$amount,
      _ref$titleDisabled = _ref.titleDisabled,
      titleDisabled = _ref$titleDisabled === void 0 ? '' : _ref$titleDisabled;
    super({
      title,
      amount,
      titleDisabled
    });
    this._regex = /{amount}/gi;
    this.enabled = true;
    this.dimmed = false; 

    this.updateTitle(title);
    this.log = new svs.core.log.Logger('payfooter:sum:numbers');
    this.clear();
  }
  split(number) {
    return number.toString().split('').map(Number);
  }
  updateTitle(title) {
    if (title.indexOf('{amount}') < 0) {
      this.enabled = false;
    } else {
      this.title = title;
      this.enabled = true;
    }
  }
  classNames() {
    return ['payfooter-numbers'];
  }
  update(number, text, forceDim) {
    if (text || typeof text === 'string') {
      this.updateTitle(text);
    }
    if (this.enabled && (!isNaN(number) || /^[\d ,]+$/.test(number))) {
      gsap.to(this, 0.3, {
        amount: number,
        onUpdate: () => {
          const str = this.title.replace(this._regex, svs.utils.format.Currency(this.amount));
          this.$el.innerText = "".concat(str);
        }
      });
    } else {
      this.clear();
    }
    this.dim(number, forceDim);
  }
  dim(amount, forceDim) {
    if (this.dimmed) {
      if (amount && !forceDim) {
        this.$el.style.opacity = 1;
      } else {
        this.$el.style.opacity = 0.5;
      }
    } else {
      this.$el.style.opacity = 1;
    }
  }
  set(amount, text) {
    if (text) {
      this.updateTitle(text);
    }
    const str = this.title.replace(this._regex, Math.round(amount));
    this.$el.innerText = "".concat(str);
    this.dim(amount);
  }
  clear() {
    this.$el.innerText = "".concat(this.titleDisabled);
  }
  render() {
    return this.$el;
  }
}
svs.tur.payfooter.Amount = Amount;

 })(window);